import { render, staticRenderFns } from "./Tickets.vue?vue&type=template&id=10efec4a&scoped=true&"
import script from "../tickets.js?vue&type=script&lang=js&"
export * from "../tickets.js?vue&type=script&lang=js&"
import style0 from "./Tickets.vue?vue&type=style&index=0&id=10efec4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10efec4a",
  null
  
)

export default component.exports